import React, { useEffect, useMemo, useState } from 'react';
import { ApiClient } from '../../../../api/ApiClient';
import { v2 } from '../../../../api/ApiInterfaceV2';
import { useLoader } from '../../../../platform/Hook';
import { Button, Select } from '../../../../ui';
import { useResolve } from '../../../Container';
import { Copy, Spacer } from '../../../dashboard/elements/LayoutElements';
import { labelSorter } from '../../../dashboard/Models';
import { Popup, PopupProps } from '../../../popups/Popup';
import { LocationItem, locationItem } from '../../../workspace/BoardMovePopup';


export const WorkspaceSelectPopup: React.FC<PopupProps> = ({ dismiss, args }) => {

    const { setWorkspace } = args;

    const api = useResolve(ApiClient);

    const [loading, workspaces] = useLoader(async () => api.exec(v2.admin.workspaces.list()), []);

    const items = useMemo(() =>
        workspaces?.slice()
            .filter(x => x.type !== 'library' && x.type !== 'user')
            .sort(labelSorter)
            .map(w => locationItem(w.id, w.label, false))
        , [workspaces]);

    const [selected, setSelected] = useState<LocationItem>();

    const onCancel = () => {
        setWorkspace(null);
        dismiss();
    };

    const onApply = () => {
        setWorkspace(selected?.key);
        dismiss();
    };

    useEffect(() => {
        if (items?.length) {
            setSelected(items[0]);
        }
    }, [items]);

    return <Popup w={32}>
        <Popup.Close onAction={dismiss} />
        <Popup.Title>Invite People</Popup.Title>
        <Popup.Content>
            {!loading && <>
                <Copy>
                    Please select a team:
                </Copy>
                <Spacer />
                <Select items={items} selected={selected} onChange={setSelected} />
                <Spacer />
            </>}
        </Popup.Content>
        <Popup.Actions>
            <Button disabled={!selected} variant="primary" onAction={onApply}>
                Select
            </Button>
            <Button onAction={onCancel}>
                Cancel
            </Button>
        </Popup.Actions>
    </Popup>;
};
